import { Checkbox, Stack, Text } from '@stitch-fix/mode-react';
import { useSelectEvent } from '@stitch-fix/event-reporter';
import { useWardrobeParams } from '../../utils/hooks/useWardrobeParams';
type SavedItemsSubHeaderProps = {
  allOutOfStock?: boolean;
};
/**
 * <SavedItemsSubHeader /> encapsulates logic that controls the query url state
 * for setting wardrobeParams for showAvailableItems. It will disable the checkbox
 * controls if all saved items are out of stock.
 */
const SavedItemsSubHeader = ({
  allOutOfStock
}: SavedItemsSubHeaderProps) => {
  const {
    wardrobeParams,
    setWardrobeParam
  } = useWardrobeParams();
  const disableCheckBox = !wardrobeParams.showAvailableItems && allOutOfStock;
  const {
    reportSelectEvent
  } = useSelectEvent();
  const handleShowAvailableItemsChange = (e: boolean) => {
    setWardrobeParam('showAvailableItems', e);
    if (wardrobeParams.showAvailableItems) {
      reportSelectEvent({
        schema: 'select',
        name: 'in_stock_toggle',
        action_name: 'show_all'
      });
    } else {
      reportSelectEvent({
        schema: 'select',
        name: 'in_stock_toggle',
        action_name: 'show_in_stock'
      });
    }
  };
  return <Stack spacing={1} mb={1}>
      <Text setting="title-medium" align="left">
        Saved Items
      </Text>
      <Checkbox isSelected={wardrobeParams.showAvailableItems} disabled={disableCheckBox} onChange={handleShowAvailableItemsChange} aria-label="Show only available items?">
        Show only available items
      </Checkbox>
    </Stack>;
};
export default SavedItemsSubHeader;